var _style, _polygon, _path, _ellipse, _path2, _polygon2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarritoSuper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FA405C;}\n\t.st1{fill:#5A1372;}\n\t.st2{fill:#8C82A5;}\n\t.st3{fill:#E9DCFF;}\n\t.st4{opacity:0.96;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "733.1,41.6 711.4,405.1 861.7,417.2 892.5,41.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M861.7,442.3h-2l-150.2-12.1c-13.6-1.1-23.8-12.8-23-26.5l21.6-363.5c0.8-13.2,11.7-23.5,24.9-23.5h159.5 c13.8,0,25,11.1,25,24.9c0,0.7,0,1.5-0.1,2.2l-30.3,375.8C886,432.6,874.9,442.5,861.7,442.3z M737.9,381.7l101,8.2l26.6-323.8 H756.6L737.9,381.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 595.9,
    cy: 300.4,
    rx: 75.6,
    ry: 108.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M595.9,435.2c-30.7-1.1-58.9-17.1-75.4-43c-35.9-55.9-35.9-127.7,0-183.6c24.5-41.6,78.1-55.5,119.7-31.1 c12.8,7.5,23.5,18.2,31.1,31.1c36.1,55.9,36.1,127.7,0,183.6C654.8,418.1,626.6,434.2,595.9,435.2z M595.9,219 c-13.1,1.4-24.8,8.9-31.6,20.2c-23.2,37.4-23.2,84.8,0,122.2c8,17.5,28.6,25.2,46,17.2c7.6-3.5,13.7-9.6,17.2-17.2 c23.2-37.4,23.2-84.8,0-122.2C620.7,227.9,609,220.4,595.9,219L595.9,219z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "772.2,136.2 802.5,417.2 728.5,417.2 664.1,90.1 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.5,442.3h-74c-12,0-22.2-8.5-24.5-20.2L639.6,94.9c-1.8-9.1,1.5-18.4,8.8-24.2c7.2-5.8,17-7.1,25.5-3.5 l108.1,46c8.3,3.5,14.1,11.2,15,20.2l30.3,281.1c0.8,7.1-1.5,14.1-6.3,19.4C816.4,439.2,809.6,442.2,802.5,442.3z M749.1,391.8h25.7 L749,153l-51.2-21.8L749.1,391.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846.5,800.3H461.6c-75.8-0.2-142.3-50.7-162.7-123.8l-127-459.9c-6.6-23.9-28.3-40.4-53.1-40.4H25.2 C11.3,176.2,0,164.9,0,150.9s11.3-25.2,25.2-25.2l0,0h93.5c47.1,0.2,88.4,31.7,101,77.2l127.1,460c14.3,51.4,61.1,87,114.4,87.2 h384.9c13.8-0.9,25.7,9.6,26.6,23.4c0.9,13.8-9.6,25.7-23.4,26.6c-1.1,0.1-2.1,0.1-3.2,0L846.5,800.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.2,671c-11.2,0-21.1-7.5-24-18.3l-90-325.1c-3.6-13.4,4.3-27.2,17.7-30.8c2.1-0.6,4.3-0.9,6.4-0.9h630.9 c36.8,0,66.7,29.8,66.7,66.6c0,7.7-1.3,15.4-3.9,22.6l-86.3,242.4c-9.4,26.6-34.6,44.3-62.8,44.3L342.2,671z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M883.2,320.8c23,0,41.7,18.7,41.7,41.7c0,4.8-0.8,9.5-2.4,14l-86.3,242.4c-5.9,16.6-21.6,27.8-39.3,27.8H342.4 L252.6,321h630.9 M883.4,270.5H252.4c-27.9,0.3-50.2,23.2-49.9,51.1c0,4.1,0.6,8.3,1.7,12.3l90,325.7c6.1,21.6,25.8,36.5,48.2,36.7 h454.4c38.7,0,73.2-24.2,86.3-60.6l86.3-242.4c17-47.7-7.9-100.2-55.6-117.2c-9.9-3.5-20.3-5.3-30.8-5.3L883.4,270.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 457.2,
    cy: 869.9,
    r: 89.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457,805.4c35.6,0,64.4,28.8,64.4,64.4c0,35.6-28.8,64.4-64.4,64.4c-35.6,0-64.4-28.8-64.4-64.4 c0,0,0-0.1,0-0.1c0-35.5,28.8-64.3,64.3-64.3C456.9,805.4,456.9,805.4,457,805.4 M457,755.4c-63.2-0.1-114.5,51.1-114.5,114.3 c-0.1,63.2,51.1,114.5,114.3,114.5c63.2,0.1,114.5-51.1,114.5-114.3c0,0,0-0.1,0-0.1C571.2,806.7,520.1,755.6,457,755.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 754.4,
    cy: 869.9,
    r: 89.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.4,805.4c35.6,0,64.4,28.8,64.4,64.4c0,35.6-28.8,64.4-64.4,64.4c-35.6,0-64.4-28.8-64.4-64.4 c0,0,0-0.1,0-0.1C690,834.2,718.8,805.4,754.4,805.4 M754.4,755.4c-63.2,0-114.4,51.2-114.4,114.4c0,63.2,51.2,114.4,114.4,114.4 c63.2,0,114.4-51.2,114.4-114.4l0,0C868.7,806.7,817.5,755.5,754.4,755.4z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.9,663.2c-9,0-16.3-7.3-16.3-16.3V299.7c-0.7-9,6-16.8,14.9-17.5c9-0.7,16.8,6,17.5,14.9 c0.1,0.9,0.1,1.7,0,2.6V647C610.1,655.9,602.8,663.2,593.9,663.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M759.9,663.2h-1.2c-8.9-0.6-15.6-8.4-15-17.3c0,0,0-0.1,0-0.1l25.7-347.4c0.7-8.9,8.4-15.6,17.4-14.9 s15.6,8.4,14.9,17.4l-25.7,347.3C775.5,656.7,768.4,663.3,759.9,663.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.1,674c-8.1,0-14.9-6-16.1-14l-47.3-358.2c-1.2-8.9,5.1-17,13.9-18.2s17,5.1,18.2,13.9l47.4,358.2 c1.1,8.9-5.1,17-13.9,18.2L445.1,674z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M903.3,499.3h-616c-9,0.7-16.8-6-17.5-14.9c-0.7-9,6-16.8,14.9-17.5c0.9-0.1,1.7-0.1,2.6,0h616 c9-0.7,16.8,6,17.5,14.9c0.7,9-6,16.8-14.9,17.5C905,499.4,904.2,499.4,903.3,499.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarritoSuper);
export default __webpack_public_path__ + "static/media/carritoSuper.c7044fb5d769f2718030307d953514c0.svg";
export { ForwardRef as ReactComponent };